import React from 'react';
import Marquee from 'react-fast-marquee';
import './../../styles/default/testimonials.css';

const Testimonials = () => {
    const testimoniales = [
        {
            text: "Contraté a un pintor por medio de Don Honesto y en menos de 24 horas ya estaba en mi casa trabajando. Todo quedó excelente y sin complicaciones.",
            name: "Ana G.",
            role: "Zapopan",
            avatar: "https://randomuser.me/api/portraits/women/68.jpg",
        },
        {
            text: "Me urgía arreglar una fuga y no encontraba a nadie confiable. Don Honesto me resolvió el mismo día. Muy recomendado.",
            name: "David R.",
            role: "Providencia",
            avatar: "https://randomuser.me/api/portraits/men/45.jpg",
        },
        {
            text: "Como profesional, encontrar trabajo constante no era fácil. Desde que me uní a Don Honesto tengo más proyectos y clientes serios.",
            name: "Hugo M.",
            role: "Plomero ",
            avatar: "https://randomuser.me/api/portraits/men/32.jpg",
        },
        {
            text: "Mi casa necesitaba una pintada urgente antes de rentarla. Encontré Don Honesto por internet, y fue la mejor decisión. Rápidos, amables y todo quedó como nuevo.",
            name: "Marcela T",
            role: "Colinas de San Javier",
            avatar: "https://randomuser.me/api/portraits/women/53.jpg",
        },
        {
            text: "Soy electricista y antes batallaba mucho para conseguir clientes. Ahora, con Don Honesto, no solo tengo más trabajo, también me pagan puntual y me siento respaldado.",
            name: "Carlos H.",
            role: "Profesional registrado",
            avatar: "/imagenes/testimoniales/ricardo_flores.png",
        },
    ];

    return (
        <div id="testimoniales" className="banner-section">
            <p className="title-section center">¿Qué dicen de nosotros?</p>
            <h2 className='center'>Historias reales de tranquilidad</h2>

            <Marquee pauseOnHover speed={50} gradient={false}>
                {testimoniales.map((row, i) => (
                    <div className='card-testimonial' key={i}>
                        <div className='open-testimony'>“</div>
                        <div className='testimony'>
                            {row.text}
                        </div>
                        <div className='close-testimony'>”</div>
                        <div className="author">
                            <img src={row.avatar} alt={row.name} />
                            <div className='flex-column gap-10'>
                                <p className="name">{row.name}</p>
                                <p className="role">{row.role}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </Marquee>
        </div>
    );
};

export default Testimonials;